import React from 'react';
import { HelperText } from './HelperText.js';
export const FormControlMeta = ({ invalid, helperText, error, }) => (React.createElement(React.Fragment, null,
    !invalid && helperText && (React.createElement("div", { className: "mt-2" },
        React.createElement(HelperText, { invalid: invalid }, helperText))),
    invalid && error && (React.createElement("div", { className: "mt-2" },
        React.createElement(HelperText, { invalid: invalid }, error)))));
//# sourceMappingURL=FormControlMeta.js.map